// old code of without microservice
// import axios from "axios";
// // import swal from "sweetalert";
// // import Swal from "sweetalert2";
// const instance = axios.create({
//   // baseURL: "http://103.235.105.204:8080/",
//   // baseURL: "http://192.168.35.155:8080/", //old working url (mumbai server)
//   baseURL: "http://localhost:8084",   // 192.168.35.133 latest api adress(mumbai server) // new 192.168.10.223 gn server  //cloud 65.1.197.101     // https format ----https://production.petrotec.com/
//   //baseURL: "http://petrotec.co.in:8080/",
//   // "http://192.168.35.133 :8080/petrotec",  mumbai
//   headers: {
//     "Access-Control-Allow-Origin": "*",
//   },
// });

// instance.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   async function (error) {
//     console.log("error :-" + JSON.stringify(error));
//     console.log("error in axiosInstance before :-", error);


//     if (
//       error.message === "Network Error" ||
//       error.message === "Request failed with status code 404"
//     ) {
//       setTimeout(async () => {
//         let refreshToken = sessionStorage.getItem("refreshToken");
//         console.log("refresh token from axiosInstance :-", refreshToken);
//         return await axios
//           .post(
//             `http://localhost:8084/petrotec/refreshToken?refreshToken=${refreshToken}`
//           )
//           .then((tokenRefreshResponse) => {
//             console.log(
//               "tokenRefreshResponse :-",
//               tokenRefreshResponse.data.message
//             );
//             sessionStorage.setItem("token", tokenRefreshResponse.data.message);
//             return Promise.resolve();
//           });
//       }, 200);
//     }

//     console.log("Rest promise error");
//     return Promise.reject(error);
//   }
// );

// export default instance;

// without
  //  headers: {
//     "Access-Control-Allow-Origin": "*",
//   },

// import axios from "axios";

// const instance = axios.create({
//   baseURL: "http://localhost:8084", 
//   headers: {
//     "Content-Type": "application/json", 
//   },
// });

// instance.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   async function (error) {
//     console.error("Axios error:", error);

//     if (
//       error.message === "Network Error" ||
//       error.message.includes("status code 404")
//     ) {
//       const refreshToken = sessionStorage.getItem("refreshToken");

//       if (refreshToken) {
//         try {
//           const res = await instance.post(`/petrotec/refreshToken?refreshToken=${refreshToken}`);
//           sessionStorage.setItem("token", res.data.message);
//           return Promise.resolve(res);
//         } catch (refreshError) {
//           console.error("Refresh failed:", refreshError);
//           return Promise.reject(refreshError);
//         }
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default instance;





// this code to run test server and production server based on hostname in microservice

import axios from "axios";

let baseURL = "";

const currentHost = window.location.hostname;


if (
  currentHost === "150.140.8.191" ||
  currentHost === "petropulse-test.petrotec.com"
) {
  baseURL = "https://petropulse-test.petrotec.com";
}

else if (currentHost === "petropulse.petrotec.com") {
  baseURL = "https://petropulse.petrotec.com";
}
// Default fallback
else {
  baseURL = "https://petropulse-test.petrotec.com";
}

const instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token =
      sessionStorage.getItem("token") ||
      localStorage.getItem("token") ||
      sessionStorage.getItem("Token") ||
      localStorage.getItem("Token") ||
      sessionStorage.getItem("jwt") ||
      localStorage.getItem("jwt");

    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;




